export enum Environment {
  Development = "development",
  Staging = "staging",
  Production = "production"
}